// extracted by mini-css-extract-plugin
export default {"addToSlackButton":"addToSlackButton_addToSlackButton__YTnKH"};